import React, { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import ArrowBackIosNewSharpIcon from '@mui/icons-material/ArrowBackIosNewSharp';
import Paper from '@mui/material/Paper';
import { visuallyHidden } from '@mui/utils';
import Divider from '@mui/material/Divider';
import styled from '@emotion/styled';
import Select from "react-select";
import * as moment from 'moment';
import { FormGroup, } from "reactstrap";
import * as routes from "../../../Router/RoutesURL";
import { createNotification } from '../../../Config/NotificationToast';
import { updateIsActiveStatus } from '../../../redux/actions/MasterDataAction/ProgramAction/programActions';
import { deleteMasterDataModule } from '../../../redux/actions/MasterDataAction/RecipeCollection/RecipeCollectionAction';
import Delete from "../../../assets/images/CommonComponent/trash.svg";
import Modal from 'react-bootstrap/Modal';
import { stableSort, getComparator, rowOptions, options, getPermissionByAppName, parseJSON, } from '../../../utils/Helper'
import { getActivityList } from '../../../redux/actions/MasterDataAction/ActivityAction/ActivityAction';
import './Activity.scss';
import { Chip, CircularProgress } from '@mui/material';
import { tabKeys } from '../../../Config/Constant';

const MainHeading = styled(Typography)(({ theme }) => ({
    color: theme.palette.primary.main,
}))

const headCells = [
    {
        id: 'title',
        disablePadding: true,
        label: 'ACTIVITY TITLE',
    },
    {
        id: 'no_of_capacity',
        disablePadding: false,
        label: 'CAPACITY',
    },
    {
        id: 'booked_user',
        disablePadding: false,
        label: 'BOOKED USER COUNT',
    },
    {
        id: 'venue',
        disablePadding: false,
        label: 'VENUE',
    },
    {
        id: 'activity_date',
        disablePadding: false,
        label: 'ACTIVITY DATE',
    },
    {
        id: 'stop_activity_date',
        disablePadding: false,
        label: 'STOP TIME',
    },
    {
        id: 'frequency',
        disablePadding: false,
        label: 'FREQUENCY',
    },
    {
        id: 'activity_time',
        disablePadding: false,
        label: 'ACTIVITY TIME',
    },
    {
        id: 'is_active',
        disablePadding: false,
        label: 'STATUS',
    },
    {
        id: 'action',
        disablePadding: false,
        label: 'ACTION',
        disableSorting: true
    },
];

const EnhancedTableHead = (props) => {
    const { order, orderBy, onRequestSort } = props;
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };

    return (
        <TableHead>
            <TableRow>
                {headCells.map((headCell) =>
                (<TableCell
                    key={headCell.id}
                    align='left'
                    padding={headCell.disablePadding ? 'none' : 'normal'}
                    sortDirection={orderBy === headCell.id ? order : false}
                >
                    <TableSortLabel
                        active={orderBy === headCell.id && !headCell.disableSorting}
                        direction={orderBy === headCell.id ? order?.toLowerCase() : "asc"}
                        onClick={createSortHandler(headCell.id)}
                        hideSortIcon={headCell.disableSorting}
                        disabled={headCell.disableSorting}
                    >
                        {headCell.label}
                        {orderBy === headCell.id ? (
                            <Box component="span" sx={visuallyHidden}>
                                {order === "DESC" ? 'sorted descending' : 'sorted ascending'}
                            </Box>
                        ) : null}
                    </TableSortLabel>
                </TableCell>)
                )}
            </TableRow>
        </TableHead>
    );
}

EnhancedTableHead.propTypes = {
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(["ASC", "DESC"]).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
};

const EnhancedTableToolbar = (props) => {
    const { activeTab, setShowLoader } = props;
    const [searchParams, setSearchParams] = useSearchParams();
    const [searchText, setSearchText] = useState(searchParams.get('filter_text') || '');
    const dispatch = useDispatch();

    const handleSearchActivity = (event) => {
        setShowLoader(true)
        const newSearchText = event.target.value;
        setSearchText(newSearchText);

        const newParams = new URLSearchParams(searchParams);
        if (newSearchText) {
            newParams.set('filter_text', newSearchText);
        } else {
            newParams.delete('filter_text');
        }
        newParams.set('page', '1');
        setSearchParams(newParams, { replace: true });
    };

    useEffect(() => {
        if (activeTab === tabKeys.masterData.ACTIVITY) {
            setSearchText(searchParams.get('filter_text') || '');
        }
    }, [activeTab, searchParams]);

    return (

        <div>
            <Toolbar sx={{
                pl: { sm: 2 },
                pt: { sm: 2 },
                pb: { sm: 2 },
                pr: { xs: 1, sm: 1 },
            }}
            >
                <div className='col-4 col-sm-4 col-md-4 col-lg-4 col-xl-3 col-xxl-3'>
                    <MainHeading
                        sx={{ flex: '1 1 100%', }}
                        variant="h6"
                        id="tableTitle"
                        component="div"
                    >
                        Daily Activities
                    </MainHeading>
                </div>
                <div className='col-8 col-sm-8 col-md-8 col-lg-8 col-xl-9 col-xxl-9 ActivitySearchDiv'>
                    <div className="mr-sm-2 searchDiv class-search ">
                        <input
                            value={searchText}
                            className="form-control mr-sm-2 class-search"
                            type="search"
                            placeholder=" Search Keyword"
                            aria-label="Search"
                            onChange={handleSearchActivity}
                        ></input>
                    </div>
                </div>
            </Toolbar>
            <Divider />
        </div>
    );
}

EnhancedTableToolbar.propTypes = {
    numSelected: PropTypes.number.isRequired,
};

const ActivityTable = (props) => {
    const { activeTab, permission} = props;
    const [searchParams, setSearchParams] = useSearchParams();
    const [selected, setSelected] = useState([]);
    const [order, setOrder] = useState(searchParams.get('order_by_type') || "");
    const [orderBy, setOrderBy] = useState(searchParams.get('order_by') || '');
    const [rowsPerPage, setRowsPerPage] = useState(parseInt(searchParams.get('limit')) || 10);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [id, setId] = useState();
    const [activityMainData, setActivityMainData] = useState('');
    const [showLoader, setShowLoader] = useState(false);
    const navigate = useNavigate()
    const activityData = useSelector(state => state?.getActivityList);
    const getActivityListData = useSelector(state => state?.getActivityList?.getActivityList);
    const dispatch = useDispatch();



    useEffect(()=>{
        if(!activityData.loading)
            setShowLoader(false)
        if(!activityData.loading && !getActivityListData?.data?.recipe_list_data?.activity_list && !activityData.error){
            setShowLoader(true)
        }
    }, [activityData.loading])

    useEffect(() => {
        if (activeTab == tabKeys.masterData.ACTIVITY) {
            const sendRequest = {
                "pageNo": searchParams.get('page') || 1,
                "pageSize": searchParams.get('limit') || 10,
                "filter_text": searchParams.get('filter_text') || '',
                "order_by": searchParams.get('order_by') || '',
                "order_by_type": searchParams.get('order_by_type') || ''
            };
            dispatch(getActivityList(sendRequest));
        }else{
            setOrder('');
            setOrderBy('');
            setRowsPerPage(10)
        }
    }, [activeTab, searchParams]);

    useEffect(() => {
        if (activityData.error !== "Ananda programs data does not exists") {
            setActivityMainData(getActivityListData && getActivityListData?.data?.recipe_list_data?.activity_list);
        }
        else {
            setActivityMainData('');
        }

    }, [getActivityListData, activityData])

    
  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order.toUpperCase() === "ASC";
    const newOrder = isAsc ? "DESC" : "ASC";
    setOrder(newOrder);
    setOrderBy(property);

    const newParams = new URLSearchParams(searchParams);
    if (property) {
        newParams.set('order_by', property);
    } else {
        newParams.delete('order_by');
    }
    if (newOrder) {
        newParams.set('order_by_type', newOrder);
    } else {
        newParams.delete('order_by_type');
    }
    newParams.set('page', '1');
    setSearchParams(newParams, { replace: true });
  };

    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelected = getActivityListData && activityMainData.map((n) => n.name);
            setSelected(newSelected);
            return;
        }
        setSelected([]);
    };

    const handleClick = (name) => {
        const selectedIndex = selected.indexOf(name);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, name);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }

        setSelected(newSelected);
    };

    const handleChangePageNext = () => {
        setShowLoader(true)
        const nextPage = getActivityListData?.data?.recipe_list_data?.current_page_no + 1;
        const newParams = new URLSearchParams(searchParams);
        newParams.set('page', nextPage.toString());
        setSearchParams(newParams, { replace: true });
    };

    const handleChangePagePrev = (newPage) => {
        setShowLoader(true)
        const prevPage = getActivityListData?.data?.recipe_list_data?.current_page_no - 1;
        const newParams = new URLSearchParams(searchParams);
        newParams.set('page', prevPage.toString());
        setSearchParams(newParams, { replace: true });
    };

    const handleChangeRowsPerPage = (event) => {
        setShowLoader(true)
        const newRowsPerPage = parseInt(event.value, 10);
        const newParams = new URLSearchParams(searchParams);
        newParams.set('limit', newRowsPerPage);
        newParams.set('page', '1');
        setSearchParams(newParams, { replace: true });
        setRowsPerPage(newRowsPerPage);
    };


    const handleChangeOption = (e, id) => {
        if (permission === "write") {
            if (e.value === "Active") {
                activityMainData.find(v => v.id === id).is_active = 1;
            } else {
                activityMainData.find(v => v.id === id).is_active = 0;
            }
            setActivityMainData(activityMainData)
            const sendRequest = {
                "feature_type": "daily_activity",
                "id": id,
                "status": e.value === "Active" ? 1 : 0
            };
            dispatch(updateIsActiveStatus(sendRequest));
            setTimeout(() => {
                const sendValue = { "pageNo": searchParams.get('page') || 1,
                "pageSize": searchParams.get('limit') || 10,
                "filter_text": searchParams.get('filter_text') || '',
                "order_by": searchParams.get('order_by') || '',
                "order_by_type": searchParams.get('order_by_type') || '' };
                dispatch(getActivityList(sendValue));
            }, 100);
        } else {
            createNotification('warning', "Access Restricted");
        }
    }

    const handleNavigateViewActivity = (activityId, activityTitle, status) => {
        navigate(routes.VIEW_ACTIVITY, {  state: { activityId, activityTitle, status, permission } })
    };

    const handleNavigate = (activityId,) => {
        if (permission === "write") {
            navigate(routes.EDIT_ACTIVITY, { state: { activityId } })
        } else {
            createNotification('warning', "Access Restricted");
        }
    };
    

    const handleDelete = (id) => {
        if (permission === "write") {
            setId(id)
            setShowDeleteModal(true);
        } else {
            createNotification('warning', "Access Restricted");
        }
    };

    const closeDeleteModal = () => {
            const sendRequestDelete = {
                "feature_type": "daily_activity",
                "ids": id,
                onSuccessCallback: ()=>{
                    if(getActivityListData?.data?.recipe_list_data?.start === getActivityListData?.data?.recipe_list_data?.end){
                        const newParams = new URLSearchParams(searchParams);
                        newParams.set("page", (getActivityListData?.data?.recipe_list_data?.current_page_no - 1 || 1));
                        setSearchParams(newParams, { replace: true });
                    }else{
                        const sendRequest = {
                            "pageNo": getActivityListData?.data?.recipe_list_data?.current_page_no || 1,
                            "pageSize": searchParams.get('limit') || 10,
                            "filter_text": searchParams.get('filter_text') || '',
                            "order_by": searchParams.get('order_by') || '',
                            "order_by_type": searchParams.get('order_by_type') || '' 
                        };
                        dispatch(getActivityList(sendRequest));
                    }
                    setShowDeleteModal(false);
                }
            };
            dispatch(deleteMasterDataModule(sendRequestDelete));
        }
    

    const cancelWarnModal = () => {
        setShowDeleteModal(false);
    }

    const handleViewGuestList = (activityId, activityTitle) => {
        navigate(routes.VIEW_INTERESTED_GUEST_LIST_ACTIVITY, { replace: true, state: { selectedActivityId: activityId, activityTitle } })
    };

    return (
        <>
            <Box sx={{ width: '100%' }} className="ActivityBox h-100">
              <Paper className='d-flex flex-column' sx={{ width: '100%', mb: 1, borderRadius: 2, height: 'calc(100% - 57px)' }}>
                        <EnhancedTableToolbar numSelected={selected.length}
                            setShowLoader={setShowLoader}
                            activeTab={activeTab} />
                        {
                            showLoader?
                            <div className='w-100 text-center py-5'>
                                <CircularProgress sx={{'color': '#74613C'}}/>
                            </div>
                            :
                            activityMainData ? <TableContainer sx={{ pt: 0, pr: 3, pb: 1, pl: 3, height: '100%' }}>
                                    <Table
                                        sx={{ minWidth: 750 }}
                                        aria-labelledby="tableTitle"
                                        size='small'
                                        stickyHeader
                                    >
                                        <EnhancedTableHead
                                            numSelected={selected.length}
                                            order={order}
                                            orderBy={orderBy}
                                            onSelectAllClick={handleSelectAllClick}
                                            onRequestSort={handleRequestSort}
                                            rowCount={getActivityListData && activityMainData?.length}
                                        />
                                        <TableBody>
                                            {
                                                activityMainData?.map((row, index) => {
                                                        const labelId = `enhanced-table-checkbox-${index}`;
                                                        const dateObj =  moment(row?.activity_datetime).format('DD/MM/YYYY');
                                                        const stopDate =  row?.stop_activity_date ? moment(row?.stop_activity_date).format('DD/MM/YYYY') : '-';
                                                        const timeObj =  moment(row?.activity_datetime).format('HH:mm:ss');
                                                        return (
                                                            <TableRow hover onClick={(event) => handleClick(event, row.title)} role="checkbox"
                                                                tabIndex={-1}
                                                                key={index}
                                                            >
                                                                <TableCell component="th" id={labelId} scope="row" padding="none" onClick={() => { handleNavigateViewActivity(row.id, row.title, row.is_active) }}
                                                                    sx={{ color: row.is_active == 1 ? '#000000' : "#AAAAAA" }}>{row.title}</TableCell>
                                                                <TableCell align="left" sx={{color: row.is_active == 1 ? '#000000' : "#AAAAAA" }}>{row.no_of_capacity
                                                                }  </TableCell>
                                                                <TableCell align="left" sx={{minWidth: 200, color: row.is_active == 1 ? '#000000' : "#AAAAAA" }}>
                                                                    {   
                                                                        row.is_repeated=='1' ?
                                                                        '-' :
                                                                        row.booked_user > 0
                                                                        ?
                                                                        <> {row.booked_user} <span className="viewLink" onClick={() => { handleViewGuestList(row.id, row.title) }}> (View Guest List)</span></>
                                                                        :
                                                                        0
                                                                    }
                                                                </TableCell>
                                                                <TableCell align="left" sx={{ color: row.is_active == 1 ? '#000000' : "#AAAAAA" }}>{row.venue}</TableCell>

                                                                <TableCell align="left" sx={{ color: row.is_active == 1 ? '#000000' : "#AAAAAA" }}>{dateObj}</TableCell>
                                                                <TableCell align="left" sx={{ color: row.is_active == 1 ? '#000000' : "#AAAAAA" }}>{stopDate}</TableCell>
                                                                <TableCell align="left flex-nowrap" sx={{ color: row.is_active == 1 ? '#000000' : "#AAAAAA" }}>
                                                                    {
                                                                        row.frequency && row.frequency !="null" ? 
                                                                        <>
                                                                        {(()=>{
                                                                            let frequency = parseJSON(row.frequency)
                                                                            return (
                                                                                <>
                                                                                <div className='mb-1'>{frequency?.key} </div>
                                                                                {
                                                                                    frequency?.key === "weekly"
                                                                                    ?
                                                                                    <>
                                                                                        
                                                                                        {
                                                                                            frequency?.value.map((item, index)=>(
                                                                                                <React.Fragment>
                                                                                                    {item.value ? <span className='chip text-capitalize rounded-pill p-2 py-1 mr-2  bg-light' style={{color:'#74613C'}}>{item.day}</span> : null} 
                                                                                                    {/* {item.value && index !== frequency?.value.length-1 ? ", " : null} */}
                                                                                                </React.Fragment>
                                                                                            ))
                                                                                        }
                                                                                    </>
                                                                                    :
                                                                                    null
                                                                                }
                                                                                </>
                                                                            )
                                                                        })()}
                                                                        </>
                                                                        :
                                                                        '-'
                                                                    }
                                                                </TableCell>
                                                                <TableCell align="left" sx={{ color: row.is_active == 1 ? '#000000' : "#AAAAAA" }}>{timeObj}</TableCell>
                                                                <TableCell align="left"
                                                                    className='ActiveInactiveCell'
                                                                    sx={{ color: row.is_active == 1 ? '#000000' : "#AAAAAA" }}>
                                                                    <Select
                                                                        className="react-select status-select"
                                                                        classNamePrefix="react-select"
                                                                        onChange={(e) => { handleChangeOption(e, row.id, row.is_active) }}
                                                                        value={row.is_active === 1 ? { label: "Active", value: "Active" } : { label: "Inactive", value: "Inactive" }}
                                                                        options={options}
                                                                        isSearchable={false}
                                                                        menuPlacement="auto"
                                                                        menuPosition="absolute"   
                                                                        menuPortalTarget={null}
                                                                        theme={(theme) => ({
                                                                            ...theme,
                                                                            isFocused: "#74613C",
                                                                            colors: {
                                                                                ...theme.colors,
                                                                                primary25: '#F5F5F5',
                                                                                primary: '#f6f4f0',

                                                                            },
                                                                        })}
                                                                        getOptionLabel={(row) => (
                                                                            <><span className={row.label === "Active" ? "ActiveClass" : "InactiveClass"} >
                                                                                {row.label}
                                                                            </span>
                                                                                {row.is_active === 1 && (
                                                                                    <div

                                                                                    ></div>
                                                                                )}
                                                                            </>
                                                                        )}
                                                                    />
                                                                </TableCell>
                                                                <TableCell align="left" className='View' >
                                                                    <ul className="list-group d-flex flex-row ">
                                                                        <li
                                                                            className={row.is_active == 1 ? 'list-group-item ViewEditClick p-0 ' : "list-group-item ViewEditNotClick p-0"}
                                                                            onClick={row.is_active == 1 ? () => { handleNavigateViewActivity(row.id, row.title, row.is_active) } : undefined}><i className="fas fa-eye mr-1"></i> View</li>
                                                                        {
                                                                            getPermissionByAppName("Activity Master") === "write" &&
                                                                            <>
                                                                                <li
                                                                                    className={row.is_active == 1 ? 'list-group-item ViewEditClick p-0 ' : "list-group-item ViewEditNotClick p-0"}
                                                                                    onClick={row.is_active == 1 ? () => { handleNavigate(row.id) } : undefined}><i className="fa fa-pen mr-1"></i> Edit</li>
                                                                                <li className="list-group-item Delete p-0" onClick={() => { handleDelete(row.id) }}><img src={Delete} className="mr-1 mb-1" alt="Avatar" width="14px" height="16px" /> Delete</li>
                                                                            </>
                                                                        }
                                                                    </ul>
                                                                </TableCell>
                                                            </TableRow>
                                                        );
                                                    })}

                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            : <div className='text-center w-100 text-muted mt-3'>No Records </div>
                        }
                    </Paper>
                    {
                        activityMainData
                        &&
                        <div className='paginationBlock'>
                            <div className='textData'><p>Items per page: </p></div>
                            <FormGroup className="FormGroup has-float-label rowsSelect class-menu-dropdown ">
                                <Select
                                    placeholder={rowsPerPage}
                                    className="react-select"
                                    classNamePrefix="react-select"
                                    value={rowsPerPage}
                                    options={rowOptions}
                                    menuPlacement="top"
                                    menuPosition="fixed"
                                    isSearchable={false}
                                    onChange={handleChangeRowsPerPage}
                                    theme={(theme) => ({
                                        ...theme,
                                        colors: {
                                            ...theme.colors,
                                            primary25: '#F5F5F5',
                                            primary: '#74613C',
                                        },
                                    })}
                                />
                            </FormGroup>
                            {getActivityListData?.data && <p className='endText'>   {getActivityListData?.data?.recipe_list_data?.start} - {getActivityListData?.data?.recipe_list_data?.end} of {getActivityListData?.data?.recipe_list_data?.total}</p>}

                            <p>                       
                                <button className={`btnPrev ${getActivityListData?.data?.recipe_list_data?.current_page_no === 1 ? "opacityBtns" : ''}`} disabled={getActivityListData?.data?.recipe_list_data?.current_page_no === 1} onClick={() => { handleChangePagePrev() }}>
                                    <ArrowBackIosNewSharpIcon className='iconBtn' />
                                </button> 
                                <button className={`btnPrev ${getActivityListData?.data?.recipe_list_data?.current_page_no === getActivityListData?.data?.recipe_list_data?.total_pages ? "opacityBtns" : ''}`} disabled={getActivityListData?.data?.recipe_list_data?.current_page_no === getActivityListData?.data?.recipe_list_data?.total_pages} onClick={() => { handleChangePageNext() }}>
                                    <ArrowForwardIosSharpIcon className='iconBtn' />
                                </button></p>
                        </div>
                    }
                </Box>
            <Modal centered className="TeamMember-modal-warning br-8" show={showDeleteModal} onHide={() => { setShowDeleteModal(false) }}>
                <Modal.Header>
                    <div className="modalText pb-4">Are you sure?</div>
                </Modal.Header>
                <Modal.Body>
                    <div className="">
                        <label htmlFor="exampleFormControlInput1" className="form-label DeleteDesc">You want to delete this record?</label>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-success greenButton mr-3" onClick={cancelWarnModal}>
                        Cancel</button>
                    <button type="button" className="btn btn-danger redButton " onClick={closeDeleteModal}>
                        Delete</button>
                </Modal.Footer>
            </Modal>
        </>
    );
}
export default ActivityTable;
